/**
 * Strip HTML tags from a string, returning plain text.
 * Useful for rendering rich-text editor output (e.g. Quill) as clean text
 * in headings, labels, and other non-rich-text contexts.
 */
export function stripHtml(html: string | null | undefined): string {
  if (!html) return '';
  return html
    .replace(/<[^>]*>/g, '')
    .replace(/&nbsp;/g, ' ')
    .replace(/&amp;/g, '&')
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .trim();
}
